<template>
  <div >


    <div class="hCnVKxh5ABYzPjWWu0rH">


      <div class="XxAT62VNpmV0liQmPpfX">
        <div class="menu-box">

          <div class="item"  v-for="(item, index) in helplist" :key="index"    @click="$parent.goNav('/wenInfo?id='+item.id)"
          >
            <span ><svg aria-hidden="true" focusable="false" data-prefix="fas"
                                       data-icon="circle-question" class="svg-inline--fa fa-circle-question " role="img"
                                       xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                                       style="margin: 0px 4px; color: rgb(166, 115, 155);">
						<path fill="currentColor"
                  d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z">
						</path>
					</svg>{{item.name}}</span></div>

        </div>
      </div>
    </div>


    <div class="portal-warpper">
      <div class="HZ0Aws4BaQP_ZM85k_mS undefined" style="display: flex;">
        <div class="left"  @click="$router.back()" ><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left"
                               class="svg-inline--fa fa-chevron-left " role="img" xmlns="http://www.w3.org/2000/svg"
                               viewBox="0 0 320 512" style="margin: 0px 4px;">
          <path fill="currentColor"
                d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z">
          </path>
        </svg></div>
        <div class="center">帮助中心</div>
        <div class="right"></div>
      </div>
    </div>


  </div>
</template>
<script>
export default {
  name: 'myhelp',
  data() {
    return { daoTime: null, balancelist: [],zhanghuguanli:false,helplist:[] };
  },
  created() {
    let that = this;
    that.gethelplist();

  },
  methods: {

    gethelplist() {
      let that = this;
      this.$parent.showLoading();

      that.$apiFun.post('/api/helplist', { type: 1 }).then(res => {
        if (res.code == 200) {
          that.helplist = res.data;
        }
        this.$parent.hideLoading();
      });
    },
    transall() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
          .post('/api/transall', {})
          .then(res => {
            that.showTost(1, res.message);
            that.getbalancelist();
            that.refreshusermoney();
            that.$parent.hideLoading();
          })
          .catch(res => {
            that.$parent.hideLoading();
          });
    },
    getbalancelist() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
          .post('/api/balancelist', {})
          .then(res => {
            if (res.code !== 200) {
              that.$parent.showTost(0, res.message);
            }
            if (res.code === 200) {
              that.balancelist = res.data;
              let balancelist = res.data;
              that.balancelist = balancelist;
            }
            that.$parent.hideLoading();
          })
          .catch(res => {
            that.$parent.hideLoading();
          });
    },
    getbalancelistNoLoding() {
      let that = this;

      that.$apiFun
          .post('/api/balancelist', {})
          .then(res => {
            if (res.code !== 200) {
              that.$parent.showTost(0, res.message);
            }
            if (res.code === 200) {
              that.balancelist = res.data;
              let balancelist = res.data;
              that.balancelist = balancelist;
            }
          })
          .catch(res => {});
    },
    refreshusermoney() {
      let that = this;
      that.$apiFun.post('/api/refreshusermoney', {}).then(res => {
        that.$parent.hideLoading();
        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {},
  beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
  },
};
</script>

<style lang="scss" scoped>
.tit {
  text-align: center;
  font-size: 0.5rem;
  font-weight: 700;
  height: 1.4rem;
  line-height: 1.4rem;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  color: #fff;
  background: url('/static/image/bg_01.c00a1854e1446ef9fbd9f5b282da92f1.c00a1854.png') no-repeat;
  background-size: 100% auto;
}
.mefs {
  color: #fff;
  height: 5.8rem;
  .conts {
    width: calc(100% - 80px);
    margin: 0 auto;
    padding-top: 0.6rem;
    .titsg {
      font-size: 0.5rem;
    }
    .mehs {
      display: flex;
      align-items: flex-end;
      height: 0.62rem;
      padding-top: 0.4rem;
      line-height: 0.62rem;

      .lfs {
        font-size: 0.5rem;
        padding-top: 6px;
        display: table-cell;
        vertical-align: bottom;
      }
      .num {
        font-size: 0.8rem;
        font-weight: 700;
        margin: 0 0.3rem 0 0.1rem;
      }
      .shua {
        width: 0.62rem;
      }
    }
  }
}
.bios {
  position: relative;
  width: calc(100% - 24px);
  margin: 0 auto;
  margin-top: -1.5rem;
  border-radius: 18px;
  background: #fff;
  overflow: hidden;
  .toptit {
    background: #f2f4fc;
    height: 1.2rem;
    display: flex;
    align-items: center;
    color: #383b43;
    font-size: 0.4rem;
    box-sizing: border-box;
    padding: 0 20px;
    .shu {
      margin-right: 15px;
      height: 0.5rem;
      width: 2px;
      background: #383b43;
    }
  }
}
.mesg {
  display: flex;
  align-items: center;
  height: 2rem;
  .bosgf {
    flex: 1;
    text-align: center;
    .top {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.4rem;
      img {
        width: 0.5rem;
        margin-right: 0.1rem;
      }
    }
    .bots {
      margin-top: 0.1rem;
      font-size: 0.5rem;
      color: #597ef7;
      span {
        font-size: 0.23rem;
      }
    }
  }
}
.typelist {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-bottom: 0.5rem;
  .lis {
    width: 25%;
    font-size: 0.3rem;
    text-align: center;
    img {
      width: 70%;
      display: block;
      margin: 0 auto;
    }
  }
}

.gamensg {
  background: #fcfcff;
  box-sizing: border-box;
  width: calc(100% - 30px);
  margin: 0 auto;
  padding: 15px;
  .titws {
    display: flex;
    font-size: 0.4rem;
    .btn {
      border: 1px solid #4080ff;
      box-sizing: border-box;
      border-radius: 0.5rem;
      color: #4080ff;
      height: 0.5rem;
      font-size: 0.3rem;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 1.8rem;
      margin-left: 0.3rem;
    }
  }
  .gameBox {
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding-top: 0.2rem;
    .lis {
      width: 25%;
      box-sizing: border-box;
      padding: 0.3rem 0;
      text-align: center;
      .name {
        color: #383b43;
        font-size: 0.3rem;
      }
      .nmey {
        color: #cbced8;
        font-size: 0.3rem;
        margin-top: 0.2rem;
      }
    }
  }
}






body>div#root {
  height: 100%;
  overflow: hidden;
  background-color: #fafaff;
}


.hCnVKxh5ABYzPjWWu0rH {
  width: 100%;
  height: 100%;
  background-size: 100% auto;
  background-repeat: repeat;
  background: #fff;
}



.Dmk8ygXskWP4jRwIhHIK {
  height: calc(100% - 2.4rem);
  box-sizing: border-box;
  margin-top: 2.4rem;
  position: relative;
  overflow: auto;
}


.Dmk8ygXskWP4jRwIhHIK>.contents {
  margin: .5333rem;
}

.Dmk8ygXskWP4jRwIhHIK>.contents>.infos, .Dmk8ygXskWP4jRwIhHIK>.contents>.platform-balance {
  margin-top: .5333rem;
  padding: .5333rem;
  background: #fff;
  box-shadow: 0 5px 10px 0 rgba(98, 119, 232, .1254901961);
  border: .5px solid rgba(204, 199, 255, .2039215686);
  border-radius: 4px;
}

.Dmk8ygXskWP4jRwIhHIK>.contents>.infos>.title, .Dmk8ygXskWP4jRwIhHIK>.contents>.platform-balance>.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Dmk8ygXskWP4jRwIhHIK>.contents>.infos>.title>span.balance, .Dmk8ygXskWP4jRwIhHIK>.contents>.platform-balance>.title>span.balance {
  font-size: .7467rem;
  border-left: .2133rem solid #715089;
  padding-left: .2667rem;
}

.Dmk8ygXskWP4jRwIhHIK>.contents>.infos>.title>span.go-transfer, .Dmk8ygXskWP4jRwIhHIK>.contents>.platform-balance>.title>span.go-transfer {
  font-size: .64rem;
  width: 3.6267rem;
  height: 1.4933rem;
  line-height: 1.4933rem;
  text-align: center;
  color: #fff;
  background-image: linear-gradient(0deg, #5a436c, #815b82 53%, #91658c);
  border-radius: .5333rem;
}

.Dmk8ygXskWP4jRwIhHIK>.contents>.infos>.balance, .Dmk8ygXskWP4jRwIhHIK>.contents>.infos>.lock-balance, .Dmk8ygXskWP4jRwIhHIK>.contents>.platform-balance>.balance, .Dmk8ygXskWP4jRwIhHIK>.contents>.platform-balance>.lock-balance {
  margin-top: .8rem;
  font-size: .8533rem;
  display: flex;
  align-items: center;
  font-weight: bold;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.Dmk8ygXskWP4jRwIhHIK>.contents>.infos>.balance svg, .Dmk8ygXskWP4jRwIhHIK>.contents>.infos>.lock-balance svg, .Dmk8ygXskWP4jRwIhHIK>.contents>.platform-balance>.balance svg, .Dmk8ygXskWP4jRwIhHIK>.contents>.platform-balance>.lock-balance svg {
  color: #7d548a;
}

.Dmk8ygXskWP4jRwIhHIK>.contents>.infos>.balance span, .Dmk8ygXskWP4jRwIhHIK>.contents>.infos>.lock-balance span, .Dmk8ygXskWP4jRwIhHIK>.contents>.platform-balance>.balance span, .Dmk8ygXskWP4jRwIhHIK>.contents>.platform-balance>.lock-balance span {
  font-size: 1.1733rem;
  font-weight: bold;
  font-family: Impact, HeadLineA, HA;
  margin-left: .2667rem;
  margin-right: .2667rem;
}

.Dmk8ygXskWP4jRwIhHIK>.contents>.infos>.balance>span {
  font-family: inherit;
}

.Dmk8ygXskWP4jRwIhHIK>.contents>.infos>.shortcut, .Dmk8ygXskWP4jRwIhHIK>.contents>.platform-balance>.shortcut {
  display: flex;
  margin-top: 1.0667rem;
  justify-content: space-between;
}

.Dmk8ygXskWP4jRwIhHIK>.contents>.infos>.shortcut>div, .Dmk8ygXskWP4jRwIhHIK>.contents>.platform-balance>.shortcut>div {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.Dmk8ygXskWP4jRwIhHIK>.contents>.infos, .Dmk8ygXskWP4jRwIhHIK>.contents>.platform-balance {
  margin-top: .5333rem;
  padding: .5333rem;
  background: #fff;
  box-shadow: 0 5px 10px 0 rgba(98, 119, 232, .1254901961);
  border: .5px solid rgba(204, 199, 255, .2039215686);
  border-radius: 4px;
}

.Dmk8ygXskWP4jRwIhHIK>.contents>.infos>.title, .Dmk8ygXskWP4jRwIhHIK>.contents>.platform-balance>.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Dmk8ygXskWP4jRwIhHIK>.contents>.infos>.title>span.balance, .Dmk8ygXskWP4jRwIhHIK>.contents>.platform-balance>.title>span.balance {
  font-size: .7467rem;
  border-left: .2133rem solid #715089;
  padding-left: .2667rem;
}

.lyheLHzQsAjx7WWg72AQ {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: .5333rem;
}

.lyheLHzQsAjx7WWg72AQ>div>div {
  width: 100%;
  text-align: center;
  margin-bottom: 5px;
  font-size: .64rem;
}

.lyheLHzQsAjx7WWg72AQ>div>div:nth-child(2) {
  color: #a96b94;
}




.HZ0Aws4BaQP_ZM85k_mS {
  height: 2.4rem;
  justify-content: space-between;
  align-items: center;
  display: flex;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 5;
  background: #fff;
  border-bottom: 1px solid rgba(217, 217, 217, .22);
}
.HZ0Aws4BaQP_ZM85k_mS>div.left {
  width: 10%;
}

.HZ0Aws4BaQP_ZM85k_mS>div.left>svg {
  font-size: .8533rem;
  padding: .64rem .4rem;
}


.HZ0Aws4BaQP_ZM85k_mS>div.center {
  position: absolute;
  left: 20%;
  width: 60%;
  text-align: center;
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 500;
  line-height: 25.2px;
  color: #0c0319;
}

.HZ0Aws4BaQP_ZM85k_mS>div.right {
  width: 30%;
  display: flex;
  justify-content: flex-end;
}



.Dmk8ygXskWP4jRwIhHIK>.contents>.infos>.shortcut>div>img, .Dmk8ygXskWP4jRwIhHIK>.contents>.platform-balance>.shortcut>div>img {
  width: 1.8133rem;
  height: 1.8133rem;
}

.Dmk8ygXskWP4jRwIhHIK>.contents>.infos>.shortcut>div>div, .Dmk8ygXskWP4jRwIhHIK>.contents>.platform-balance>.shortcut>div>div {
  width: 100%;
  text-align: center;
}



.lyheLHzQsAjx7WWg72AQ>div {
  width: 25%;
  display: flex;
  margin: .2667rem 0;
  flex-wrap: wrap;
}







.titlesss {
  font-family: PingFang SC;
  font-size: 18px !important;
  font-weight: 600 !important;
  text-align: center;
  color: #fff !important;
  height: 3.4rem !important;
}

.titlesss span {
  width: 18px;
  height: 18px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEpSURBVHgBlVQBlcIwDE3vnQAkzMHNwc0JOGAOOgcnYYcCJAAKwMFwsDkICfuBUjIYee+/bu3Pb5KmDeQYMy9kWApKQYHpE3AIIZzpnYlII+h5NB13gM11ynklsBAcQd4Kfh1OKWjBOSLyJ5KJLOl91LWJeemorWmmCXcFn2gTBfJu6UNDCfpriolymZEeioqou4xTWSbf8v8jGORIT9mG/wJ1tn9NoUkJ4rOX9YG0Tex4yQ898t3iBOfq/0WvLUx8u4qtFsyZt5OMSWSNw9Ni/+nHGqQqI3RpOhDLi13eeg8drapb+tCQjW5YpLuNyvNFavcQkitSzxBZuVcEi+mlbfMGBadCNzNPXdqEHJE3s/+M9Oz0VJgQK2SoaOx6i+xM48O2kY4ecp8Lyla57F+y++IAAAAASUVORK5CYII=);
  right: 15px !important;
}

.titlesss span svg {
  display: none;
}

.fg6ZfskHOnqaRwP2znAd {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .6);
  top: 0;
  left: 0;
  position: fixed;
  //transform: translateZ(500px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}


.IMXCn5ydwEw_jJmmMHBA {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 0;
}



.xB_gF9WZa7pfIzh7CjSA {
  height: 100%;
  position: absolute;
  width: 100%;
  left: 0;
  z-index: 1;
  background: #fff;
  border-top-left-radius: 1.066667rem;
  border-top-right-radius: 1.066667rem;
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, .2), 0px 24px 38px 3px rgba(0, 0, 0, .14), 0px 9px 46px 8px rgba(0, 0, 0, .12);
  //transform: translate3d(0, 100%, 0);
  animation: an-pop-up .5s forwards;
  overflow: hidden;
}


.xB_gF9WZa7pfIzh7CjSA.sharp {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.xB_gF9WZa7pfIzh7CjSA>.titlesss {
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: .746667rem;
  font-weight: bold;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  color: #4c4c4c;
  box-sizing: border-box;
  z-index: 2;
}

.titlesss span {
  width: 18px;
  height: 18px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEpSURBVHgBlVQBlcIwDE3vnQAkzMHNwc0JOGAOOgcnYYcCJAAKwMFwsDkICfuBUjIYee+/bu3Pb5KmDeQYMy9kWApKQYHpE3AIIZzpnYlII+h5NB13gM11ynklsBAcQd4Kfh1OKWjBOSLyJ5KJLOl91LWJeemorWmmCXcFn2gTBfJu6UNDCfpriolymZEeioqou4xTWSbf8v8jGORIT9mG/wJ1tn9NoUkJ4rOX9YG0Tex4yQ898t3iBOfq/0WvLUx8u4qtFsyZt5OMSWSNw9Ni/+nHGqQqI3RpOhDLi13eeg8drapb+tCQjW5YpLuNyvNFavcQkitSzxBZuVcEi+mlbfMGBadCNzNPXdqEHJE3s/+M9Oz0VJgQK2SoaOx6i+xM48O2kY4ecp8Lyla57F+y++IAAAAASUVORK5CYII=);
  right: 15px !important;
}

.xB_gF9WZa7pfIzh7CjSA>.titlesss>span {
  position: absolute;
  right: 0;
}

.xB_gF9WZa7pfIzh7CjSA>.titlesss>span>svg {
  font-size: .853333rem;
  padding: .8rem;
}
.titlesss span svg {
  display: none;
}

.xB_gF9WZa7pfIzh7CjSA>.wrapper {
  height: calc(100% - 3.1875rem);
  margin-top: 3.1875rem;
  overflow: scroll;
  overscroll-behavior: contain;
  box-sizing: border-box;
  position: relative;
}

.fm_hegCG05Wk9D5pL9R5 .account-management {
  margin-top: 47px;
  margin-bottom: 100px;
}

.fm_hegCG05Wk9D5pL9R5 ul li {
  display: flex;
  height: 2.3rem;
  align-items: center;
  justify-content: center;
  min-width: 6.4rem;
  padding: 0 .53333rem;
  margin: .6rem .53333rem 0;
  background: linear-gradient(106.86deg, #D8A2EB 0%, #B097F0 100%);
  border-radius: 8px;
  letter-spacing: 4px;
  font-size: 14px;
  color: #fff;
  box-sizing: border-box;
}






.xuL8u7N_qyffgecKGszd .bindBankCard-cont {
  margin-top: 2.4rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1rem;
}


.xuL8u7N_qyffgecKGszd .bindBankCard-cont .card {
  background: #fff;
  border-top: 1px solid #e5e5e5;
  box-shadow: 0 .1rem .2rem #d8d7d8;
  margin-bottom: .6rem;
  border-radius: 3px;
  margin-bottom: 1rem;
}

.xuL8u7N_qyffgecKGszd .bindBankCard-cont .card>div {
  height: 1.5rem;
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.xuL8u7N_qyffgecKGszd .bindBankCard-cont .card>div:first-child {
  background-color: #f6f6f6;
  padding: 0 .4rem;
}

.xuL8u7N_qyffgecKGszd .bindBankCard-cont .card>div:first-child :last-child {
  color: #aaa;
}
.xuL8u7N_qyffgecKGszd .bindBankCard-cont .card>div {
  height: 1.5rem;
  align-items: center;
  display: flex;
  justify-content: space-between;
}



.xuL8u7N_qyffgecKGszd .bindBankCard-cont .card>div:last-child {
  height: 3rem;
  padding: 0 .4rem;
}

.xuL8u7N_qyffgecKGszd .bindBankCard-cont .card>div:last-child>div {
  height: 3rem;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}


.xuL8u7N_qyffgecKGszd .bindBankCard-cont .card>div:last-child>div p:first-child {
  color: #aaa;
}
.xuL8u7N_qyffgecKGszd .bindBankCard-cont .card>div:last-child>div p {
  color: #666;
}

.xuL8u7N_qyffgecKGszd .bindBankCard-cont .card>div:last-child>div {
  height: 3rem;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}


.xuL8u7N_qyffgecKGszd .bindBankCard-cont .card>div:last-child>div p:first-child {
  color: #aaa;
}

.xuL8u7N_qyffgecKGszd .bindBankCard-cont .card>div:last-child>div:nth-child(2) p:nth-child(2) {
  color: #fc0;

}



.xuL8u7N_qyffgecKGszd .actions {
  padding-left: 1rem;
  padding-right: 1rem;
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}


.xuL8u7N_qyffgecKGszd .actions p {
  background-size: 100% 100%;
  height: 30px;
  line-height: 30px;
  width: 6rem;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  margin: 0 .5rem;
  background: linear-gradient(306deg, #593f6c 0%, #947be7 100%);
}

.xuL8u7N_qyffgecKGszd .bankcard-tips {
  padding-left: 1rem;
  padding-right: 1rem;
}

.xuL8u7N_qyffgecKGszd .bankcard-tips .tips-red {
  color: red;
}






.hCnVKxh5ABYzPjWWu0rH {
  width: 100%;
  height: 100%;
  background-size: 100% auto;
  background-repeat: repeat;
  background: #fff;
}


.XxAT62VNpmV0liQmPpfX {
  height: calc(100% - 2.4rem);
  box-sizing: border-box;
  margin-top: 2.4rem;
  position: relative;
  margin-top: 2.53rem;
}


.XxAT62VNpmV0liQmPpfX .menu-box {
  margin-top: 2.53rem;
  padding: 0 .64rem;
  background-color: #fff;
  box-shadow: 0 .14rem .43rem 0 rgba(0, 0, 0, .06);
  box-sizing: border-box;
}
.XxAT62VNpmV0liQmPpfX .menu-box>.item {
  height: 2.24rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: #707070;
  font-size: .75rem;
  border-bottom: 1px soild #f0f0f0;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}


.XxAT62VNpmV0liQmPpfX .menu-box>.item>span>svg {
  width: 1.07rem;
  margin: 0 .53rem;
}





</style>



// WEBPACK FOOTER //
// src/components/money.vue